import { FaWhatsapp } from "react-icons/fa";


const ContactIcons = () => {
    return(
        <div className=" rounded-full fixed right-[0.75rem] desktop:right-[2.5rem] bottom-[2.5rem]  ">
          <a href="https://wa.me/15618976749" alt="" className=" text-[2.5rem] desktop:text-[3.5rem] text-black opacity-60 hover:desktop:text-[3.6rem] ease-in-out duration-100   "><FaWhatsapp className="my-[1rem]"/></a>  
        </div>
    )
}

export default ContactIcons; 